<ng-container>
  <div  *ngIf="saving"
        [style.height.%]="100"
        [class.ap-cr-disable-cell]="true"></div>
  <div [style.height.%]="100">
    <detail-off-cell *ngIf="!fieldIsActive"></detail-off-cell>
    <ap-crop-rotation-detail-big-cell *ngIf="fieldIsActive"
                                      [availableCropTypes]="availableCropTypes"
                                      [strawHarvestedId]="strawHarvestedId"
                                      [disableControls]="disableControls"
                                      [saving]="saving"
                                      [data]="data"
                                      (saveCell)="saveCell.emit($event)"
                                      (getFocus)="getFocus.emit($event)"
                                      (lostFocus)="lostFocus.emit($event)"
    ></ap-crop-rotation-detail-big-cell>
  </div>
</ng-container>
